<template>
  <div class="main">
    <div class="block" v-if="show">
      <el-carousel
        height="40px"
        direction="vertical"
        :interval="30000"
        arrow="never"
      >
        <el-carousel-item v-for="item in imgs" :key="item.id">
          <a :href="item.asrc" target="_block">
            <img :src="item.imgsrc" alt="" srcset="" />
          </a>
        </el-carousel-item>
      </el-carousel>
      <div class="yc">
        <i
          class="el-icon-circle-close"
          style="cursor: pointer"
          @click="show = false"
        ></i>
      </div>
    </div>
  </div>
</template>
<script>
import bottom1 from "../assets/img/bottom1.gif";
import bottom2 from "../assets/img/bottom2.gif";
import bottom3 from "../assets/img/bottomERP.gif";
export default {
  data() {
    return {
      show: true,
      imgs: [
        {
          id: 1,
          imgsrc: bottom1,
          asrc: "http://dqb-1688.com/ApiOpen/index1.html",
        },

        {
          id: 2,
          imgsrc: bottom3,
          asrc: "http://www.pengdainfo.com/online/pages/erp000/",
        },
        {
          id: 3,
          imgsrc: bottom2,
          asrc: "http://dqb-1688.com/ApiOpen/index2.html",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.yc {
  position: absolute;
  right: 0;
  bottom: 20px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 40px;
  margin: 0;
}
/deep/.el-carousel__indicators--vertical {
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
}

/deep/.el-carousel__button {
  background-color: #3b3d40;
  width: 5px;
  height: 5px;
  border-radius: 50%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.block {
  position: relative;
  width: 580px;
}
.main {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.yc {
  z-index: 999;
}
</style>